/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { WorkspaceId } from '@jira/servicedesk__insight-common-types-shared-types/src/toCmdbObjectTypeId.tsx';

export const getCmdbRestBaseUrl = (workspaceId: WorkspaceId): string =>
	`/gateway/api/jsm/assets/workspace/${workspaceId}/v1`;
